export const paths = {
  login: "/login",
  dashboard: "/dashboard",
  visitPlanning: "/visit-planning",
  doctors: "/doctors",
  firms: "/firms",
  employees: "/employees",
  // employee: "/employee",
  holidays: "/holidays",
  hrLeave: "/hr-leave",
  expenses: "/expenses",
  allowanceSettings: "/allowance-settings",
  master: "/master",
  designation: "/designation",
  country: "/country",
  zone: "/zone",
  headquarter: "/headquarter",
  location: "/location",
  doctorMaster: "/doctor-master",
  medicineMaster: "/medicine-master",
  tourPlan: "/tour-plans",
  sfc: "/sfc",
  routeMaster: "/route-master",
  dailyAllowance: "/daily-allowance",
  attendance: "/attendance",
  reportCallReports: "/reports/call-reports",
  reportMissedCalls: "/reports/missed-calls",
  reportVisitTracker: "/reports/visit-tracker",
  deviceManagement: "/device-management",
  appSettings: "/settings",
};
